import { render, staticRenderFns } from "./CommWithdraw.vue?vue&type=template&id=4bc60bb9&scoped=true&"
import script from "./CommWithdraw.vue?vue&type=script&lang=js&"
export * from "./CommWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./CommWithdraw.vue?vue&type=style&index=0&id=4bc60bb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc60bb9",
  null
  
)

export default component.exports